define('model/campaign-manager.model',['require','exports','module','underscore','./settings.model','model/reminder-frequency.model'],function(require, exports, module) {
  // prettier-ignore
  var _                      = require('underscore'),
      SettingsModel          = require('./settings.model'),
      ReminderFrequencyModel = require('model/reminder-frequency.model');

  var CampaignManagerModel = SettingsModel.extend({
    radioRequests: {
      'models CampaignManagerModel': '@constructor',
    },

    childModels: {
      reminder_frequency: ReminderFrequencyModel,
      reminder_frequency_final_period_of_campaign: ReminderFrequencyModel,
      reminder_frequency_past_due: ReminderFrequencyModel,
    },
  });

  module.exports = CampaignManagerModel;
});

